import { Injectable } from '@angular/core';

import { Observable, pipe } from 'rxjs';
import { User } from '../models/user';
import { UserService } from './user.service';
import { PositionService } from './position.service';
import { combineLatest } from 'rxjs';
import { Coords } from './../models/coords';
import { map, debounceTime, auditTime } from 'rxjs/operators';
import { LocalStorage } from 'ngx-webstorage';

@Injectable({ providedIn: 'root' })
export class UserPositionService {
    // Dummy user object used in the case no anonymous or authenticated user is logged in
    private dummyUser: User = new User('dummy-user');
    @LocalStorage('enableLocationEmulation', false) public enableLocationEmulation: boolean;

    constructor(
        private userService: UserService,
        private positionService: PositionService
    ) { }

    public async init(): Promise<void> {
    }

    /**
    * Watch user - watch user rights and user database content and position
    * This is just a helper service function which combines data
    * from the login.service, user.service and gps.service to get the currently
    * signed in user (and populate the position from GPS in the user object)
    * @return Returns a database user object
    */
    public watchUserPosition(): Observable<User> {

        let userObs = this.userService.watchCurrentUser().pipe(debounceTime(250));
        let posObs = this.positionService.watchPosition();

        return combineLatest(userObs, posObs).pipe(map((userPos: [User | null, Coords]) => {
            // Use currently signed in user or fallback to user dummy
            let user = userPos[0] ? userPos[0] : this.dummyUser;
            // Update position from position service
            user.position = userPos[1];
            return user;
        }));
    }

    /**
     * Set the position of a user and emulate position if the user correcponds to 
     * the current active user.
     */
    public setUserPosition(coords: Coords, user: User = this.userService.currentUser) {
        user.position = coords;
        if(user.key == this.userService.currentUser.key) {
            this.positionService.emulatePosition(coords);
        }
    }

    public setUserRadius(radius: number, user: User = this.userService.currentUser) {
        this.userService.currentUser.userRadius = radius;
    }

    public async enableEmulation(enable: boolean) {
        // Persist emulation setting in local storage
        this.enableLocationEmulation = enable;
    }

    public toggleEnableEmulation() {
        this.enableEmulation(!this.enableLocationEmulation);
    }
}
